import React from 'react';

const Icon = (props) => {
  const { className, glyph, ...restProps } = props;

  return (
    <svg className={className} {...restProps}>
      <use xlinkHref={`#${glyph}`} />
    </svg>
  );
};

export default Icon;
